// extracted by mini-css-extract-plugin
export var container = "styles-module--container--Pre7y";
export var heading = "styles-module--heading--Cd1Te";
export var description = "styles-module--description--lSXvw";
export var slideWrapper = "styles-module--slideWrapper--mdGLE";